module.exports = __webpack_public_path__ + "static/img/Gacha03.f701414.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/gasha/Gacha03.png
// module id = V+ng
// module chunks = 1